import React, { useRef, useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

// Material ui
import {
    Grid,
    IconButton,
    TextField
} from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Icons
import { Search } from '@/assets/icons';

// Variables

// Styles
import '../Inputs.scss';
import VARIABLES from '@/assets/variables';

interface Props {
    value?: string;
    onChange: (_value: string) => void;
    placeholder?: string;
    id?: string;
    variant?: string;
    label?: string;
    disabled?: boolean;
    searchButton?: boolean;
    md?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

const SearchInput: React.FC<Props> = ({
    value,
    variant = 'primary',
    onChange,
    placeholder,
    label,
    disabled = false,
    searchButton = false,
    id,
    md,
    lg,
    sm,
    xs
}) => {
    const [ tempValue, setTempValue ] = useState('');
    const inputRef = useRef<HTMLInputElement>();
    const idRef = useRef(uuid());

    // Handle focus event
    useEffect(() => {
        const handleFocus = (e: FocusEvent) => {
            const target = (e.target as HTMLInputElement);
            if (target && target.parentElement)
                target.parentElement.id = target.parentElement.id === 'ui-Input-focused' ? idRef.current : 'ui-Input-focused';
        };
        if (!inputRef.current) return;
        inputRef.current.addEventListener('focus', handleFocus);
        inputRef.current.addEventListener('blur', handleFocus);
    }, [ inputRef ]);

    return (
        <Grid
            className={`ui-SearchInput${!label ? ' labelless-input' : ''}`}
            item
            md={md}
            lg={lg}
            sm={sm}
            xs={xs === 1 ? undefined : xs}
            style={{
                width: xs === 1 ? '6rem' : ''
            }}
        >
            { label && (
                <Typography
                    variant="input-head"
                    className="ui-Input-label"
                    color={disabled ? 'content-light' : 'primary-dark'}
                >
                    {label}
                </Typography>
            )}
            <TextField
                id={id}
                className={`ui-Input-container ${variant}`}
                placeholder={placeholder}
                disabled={disabled}
                size="small"
                variant="outlined"
                value={searchButton ? tempValue : (value || '')}
                onChange={({ target }) => (searchButton
                    ? setTempValue(target.value)
                    : onChange(target.value))}
                InputProps={{
                    endAdornment: searchButton ? (
                        <>
                            <IconButton
                                disableRipple
                                disableFocusRipple
                                onClick={() => onChange(tempValue)}
                                className="ui-Search-button"
                            >
                                <Search
                                    color={disabled ? VARIABLES.palette.content_light : VARIABLES.palette.secondary_color}
                                    className="ui-Search-icon"
                                />
                            </IconButton>
                        </>
                    ) : (
                        <Search
                            color={disabled ? VARIABLES.palette.content_light : VARIABLES.palette.secondary_color}
                            className="ui-Search-icon"
                        />
                    )
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                inputProps={{
                    ref: inputRef
                }}
            />
        </Grid>
    );
};

export default SearchInput;
